export default __webpack_public_path__ + "static/media/icon-dot.0b273694.svg";